//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'dayjs'
export default {
	data() {
		return {
			page: {
				pageSize: 10,
				currentPage: 1,
				count: 0,
				loading: false,
			},
			myCollectList: [],
			//滑动的一些参数
			startX: 0, //开始位置
			endX: 0, //结束位置
			parentElement: 0 //date-type 的值
		}
	},
	components: {},
	onLoad() {
		this.queryData()
	},
	onReachBottom() {
		if (this.myCollectList.length < this.page.count) {
			this.queryData()
		}
	},
	onPullDownRefresh() {
		this.myCollectList = []
		this.page.currentPage = 1
		this.queryData('refresh')
	},
	methods: {
		//滑动开始
		touchStart(e) {
			// 记录初始位置
			this.startX = e.touches[0].pageX;
		},
		//滑动结束
		touchEnd(event, i) {
			// 当前滑动的父级元素
			let query = uni.createSelectorQuery().in(this)
			query.select('.activeBox' + i).boundingClientRect()
			query.exec(res => {
				this.myCollectList[i].parentElement = res[0].dataset.type
			})
			// 记录结束位置
			this.endX = event.changedTouches[0].pageX
			// 左滑
			if (this.myCollectList[i].parentElement == 0 && this.startX - this.endX > 30) {
				for (let i = 0; i < this.myCollectList.length; i++) {
					this.myCollectList[i].parentElement = 0;
				}
				this.$nextTick(() => {
					this.myCollectList[i].parentElement = 1
				})
			}
			//右滑
			if (this.myCollectList[i].parentElement == 1 && this.startX - this.endX < 30) {
				for (let i = 0; i < this.myCollectList.length; i++) {
					this.myCollectList[i].parentElement = 0;
				}
				this.$nextTick(() => {
					this.myCollectList[i].parentElement = 0
				})
			}
			this.startX = 0
			this.endX = 0
		},
		//取消收藏
		delData(t, i) {
			let _this = this
			uni.showModal({
				content: '确定取消收藏吗？',
				success(res) {
					if (res.confirm) {
						_this.$ajax({
							method: 'post',
							url: '/weChat/mycollection/delete',
							data: {
								id: t.id
							}
						}).then(res => {
							_this.myCollectList = []
							_this.page.currentPage = 1
							_this.queryData('refresh')
						})
					} else if (res.cancel) {

					}
				}
			})
		},
		//跳转到相应收藏页面
		toDetail(item) {
			let path = {
				1001: `/pages/beauty/detail?id=${item.collectionId}`,
				1002: `/pages/hotel/detail?id=${item.collectionId}`,
				1003: `/pages/cate/detail?id=${item.collectionId}`,
				1004: `/pages/specialty/order?id=${item.collectionId}`,
				1005: `/pages/route/detail?id=${item.collectionId}`,
				2001: `/pages/beauty/detail?id=${item.collectionId}`,
				2002: `/pages/hotel/detail?id=${item.collectionId}`,
				2003: `/pages/cate/detail?id=${item.collectionId}`
			}
			if (item.productGroupType) {
				uni.navigateTo({
					url: path[item.productGroupType]
				})
			} else if (item.collectionType === 40) {
				uni.navigateTo({
					url: `/pages/guide/detail?id=${item.collectionId}`,
				})
			}
		},
		queryData(status) {
			this.page.loading = true
			this.$ajax({
				method: 'post',
				url: '/weChat/mycollection/queryPage',
				data: {
					userId: this.$store.state.userInfo.memberId, // 创建人id
					...this.page,
				}
			}).then(res => {
				let array = []
				res.data = res.data ? res.data.map((t, i) => {
					array.push(
						Object.assign({}, t, {
							parentElement: 0
						})
					)
				}) : []

				this.myCollectList.push.apply(this.myCollectList, this.renderData(array))
				this.page.loading = false
				this.page.count = res.count
				this.page.currentPage += 1
				if (status === 'refresh') {
					uni.stopPullDownRefresh();
				}
			})
		},
		renderData(data) {
			return data.map(t => {
				return {
					...t,
					collectionName: t.collectionName.slice(0,20),
					typeDescribe: t.typeDescribe.split(',')
				}
			})
		}
	}
}
